export class memberWholesaleQualifiedRequestModel {
     memberId : string;
     memberNdpFlag : string;
     memberHomeCountry : string;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/models/memberTypeorLevel-model.ts